import gql from 'graphql-tag';

export const PERFORMANCE_QUERY = gql`
    query Performance($ticker: String!) {
        mutualFund(ticker: $ticker) {
            name: shortName
            shortName
            inceptionDate
            ytdMonthlyAsOfDate
            contributionGrowth {
                effectiveDate
                fundGrowthAmounts {
                    asOfDate
                    balance
                }
                benchmarkContributionGrowths {
                    benchmarkSymbol
                    benchmarkName
                    defaultBenchmarkIndicator
                    growthAmounts {
                        asOfDate
                        balance
                    }
                }
            }
        }
    }
`;

export const ETF_PERFORMANCE_QUERY = gql`
    query Performance($ticker: String!) {
        exchangeTradedFund(ticker: $ticker) {
            name
            inceptionDate
            benchmarks {
                benchmarkCode
                benchmarkName
                benchmarkType
            }
            contributionGrowth {
                effectiveDate
                fundGrowthAmounts {
                    asOfDate
                    balance
                }
                benchmarkContributionGrowths {
                    benchmarkSymbol
                    benchmarkName
                    defaultBenchmarkIndicator
                    growthAmounts {
                        asOfDate
                        balance
                    }
                }
            }
        }
    }
`;
